/* components/Preloader.svelte generated by Svelte v3.20.1 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal
} from "svelte/internal";

function add_css() {
	var style = element("style");
	style.id = "svelte-ao1o5c-style";
	style.textContent = ".lds-ellipsis.svelte-ao1o5c.svelte-ao1o5c{display:inline-block;position:relative;width:80px;height:80px}.lds-ellipsis.svelte-ao1o5c div.svelte-ao1o5c{position:absolute;top:33px;width:13px;height:13px;border-radius:50%;background:#cef;animation-timing-function:cubic-bezier(0, 1, 1, 0)}.lds-ellipsis.svelte-ao1o5c div.svelte-ao1o5c:nth-child(1){left:8px;animation:svelte-ao1o5c-lds-ellipsis1 0.6s infinite}.lds-ellipsis.svelte-ao1o5c div.svelte-ao1o5c:nth-child(2){left:8px;animation:svelte-ao1o5c-lds-ellipsis2 0.6s infinite}.lds-ellipsis.svelte-ao1o5c div.svelte-ao1o5c:nth-child(3){left:32px;animation:svelte-ao1o5c-lds-ellipsis2 0.6s infinite}.lds-ellipsis.svelte-ao1o5c div.svelte-ao1o5c:nth-child(4){left:56px;animation:svelte-ao1o5c-lds-ellipsis3 0.6s infinite}@keyframes svelte-ao1o5c-lds-ellipsis1{0%{transform:scale(0)}100%{transform:scale(1)}}@keyframes svelte-ao1o5c-lds-ellipsis3{0%{transform:scale(1)}100%{transform:scale(0)}}@keyframes svelte-ao1o5c-lds-ellipsis2{0%{transform:translate(0, 0)}100%{transform:translate(24px, 0)}}";
	append(document.head, style);
}

function create_fragment(ctx) {
	let div4;

	return {
		c() {
			div4 = element("div");

			div4.innerHTML = `<div class="svelte-ao1o5c"></div> 
	<div class="svelte-ao1o5c"></div> 
	<div class="svelte-ao1o5c"></div> 
	<div class="svelte-ao1o5c"></div>`;

			attr(div4, "class", "lds-ellipsis svelte-ao1o5c");
		},
		m(target, anchor) {
			insert(target, div4, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div4);
		}
	};
}

class Preloader extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-ao1o5c-style")) add_css();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Preloader;